import {
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  Text,
  VStack,
  HStack,
} from "@chakra-ui/react";
import { MdCheckCircle, MdCancel } from "react-icons/md";
import { Approval } from "types";

interface ApprovalsListProps {
  approvals: Approval[];
  children: React.ReactNode;
}

export default function ApprovalsList({
  approvals,
  children,
}: ApprovalsListProps) {
  return (
    <Popover placement="bottom" trigger="click">
      <PopoverTrigger>{children}</PopoverTrigger>
      <PopoverContent w="fit-content" minW="200px">
        <PopoverBody>
          <VStack align="stretch" spacing={2}>
            {approvals.length === 0 && (
              <Text fontSize="sm" textAlign={"center"}>
                No approvals yet
              </Text>
            )}
            {approvals.map((approval, index) => (
              <HStack key={index} justify="space-between">
                <Text fontSize="sm">
                  {approval?.user_created?.first_name} (
                  {approval?.approver_role?.name}) -{" "}
                  {approval?.user_created?.email}
                </Text>
                {approval.satisfactory ? (
                  <MdCheckCircle color="green" />
                ) : (
                  <MdCancel color="red" />
                )}
              </HStack>
            ))}
          </VStack>
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
}
